import { Box, Typography } from "@mui/material";
import { InfiniteList } from "components/list/infinity-list";
import { IGrantVestmentDistribution } from "interfaces/grant-vestment-request-distribution";
import { shortFormat } from "utils/date-format";
import { moneyFormat } from "utils/money-format";
interface GrantVestmentDistributionListProps {
  grantVestmentId: number;
}

export const GrantVestmentDistributionList: React.FC<
  GrantVestmentDistributionListProps
> = ({ grantVestmentId }) => {
  return (
    <Box>
      <InfiniteList<IGrantVestmentDistribution>
        endpoint={`fund-gv-distribution/list`}
        isTable={true}
        limit={5}
        queryParams={{ "filter[grantVestmentId]": `${grantVestmentId}` }}
        columns={[
          {
            header: "Fund Name",
            renderCell: function render({ fund }) {
              return <Typography>{fund.fundAccountName}</Typography>;
            },
          },
          {
            header: "Amount",
            renderCell: function render({ amount }) {
              return <Typography>${moneyFormat(amount)}</Typography>;
            },
          },
          {
            header: "Distributed Amount",
            renderCell: function render({ amountDistributed }) {
              return <Typography>${moneyFormat(amountDistributed)}</Typography>;
            },
          },

          {
            header: "Reference Date",
            renderCell: function render({ referenceDate }) {
              return <Typography>{shortFormat(referenceDate)}</Typography>;
            },
          },
          {
            header: "Distribution Date",
            renderCell: function render({ distributionDate }) {
              return <Typography>{shortFormat(distributionDate)}</Typography>;
            },
          },
          {
            header: "DPI",
            renderCell: function render({ dpi }) {
              return <Typography>{dpi}</Typography>;
            },
          },
        ]}
        tableProps={{
          stickyHeader: true,
          headerBgColor: "grey.200",
          responsive: true,
        }}
      />
    </Box>
  );
};
